"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateSharing = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const TimeAndDate_1 = require("../utils/time/TimeAndDate");
const ResponseBase_1 = require("../ResponseBase");
const DecodableToken_1 = require("../utils/DecodableToken");
var TemplateSharing;
(function (TemplateSharing) {
    class ExportTokenPayload extends ResponseBase_1.ResponseBase {
    }
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsString)(),
        (0, tslib_1.__metadata)("design:type", String)
    ], ExportTokenPayload.prototype, "templateId", void 0);
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsNumber)(),
        (0, tslib_1.__metadata)("design:type", Number)
    ], ExportTokenPayload.prototype, "version", void 0);
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsString)(),
        (0, tslib_1.__metadata)("design:type", String)
    ], ExportTokenPayload.prototype, "name", void 0);
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsString)(),
        (0, tslib_1.__metadata)("design:type", String)
    ], ExportTokenPayload.prototype, "businessName", void 0);
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsString)(),
        (0, tslib_1.__metadata)("design:type", String)
    ], ExportTokenPayload.prototype, "businessId", void 0);
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsOptional)(),
        (0, class_validator_1.IsInstance)(TimeAndDate_1.TimeAndDate),
        (0, tslib_1.__metadata)("design:type", TimeAndDate_1.TimeAndDate)
    ], ExportTokenPayload.prototype, "expiry", void 0);
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsString)(),
        (0, tslib_1.__metadata)("design:type", String)
    ], ExportTokenPayload.prototype, "tokenId", void 0);
    TemplateSharing.ExportTokenPayload = ExportTokenPayload;
    class ExportToken extends (0, DecodableToken_1.makeDecodableToken)(ExportTokenPayload) {
    }
    TemplateSharing.ExportToken = ExportToken;
    class ExportRequest extends ResponseBase_1.ResponseBase {
    }
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsUUID)(),
        (0, tslib_1.__metadata)("design:type", String)
    ], ExportRequest.prototype, "templateId", void 0);
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsOptional)(),
        (0, class_validator_1.IsInstance)(TimeAndDate_1.TimeAndDate),
        (0, tslib_1.__metadata)("design:type", TimeAndDate_1.TimeAndDate)
    ], ExportRequest.prototype, "expiry", void 0);
    TemplateSharing.ExportRequest = ExportRequest;
    class ExportResponse extends ResponseBase_1.ResponseBase {
    }
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsInstance)(ExportToken),
        (0, tslib_1.__metadata)("design:type", ExportToken)
    ], ExportResponse.prototype, "exportToken", void 0);
    TemplateSharing.ExportResponse = ExportResponse;
    class ImportRequest extends ResponseBase_1.ResponseBase {
    }
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsInstance)(ExportToken),
        (0, tslib_1.__metadata)("design:type", ExportToken)
    ], ImportRequest.prototype, "exportToken", void 0);
    TemplateSharing.ImportRequest = ImportRequest;
    class ImportResponse extends ResponseBase_1.ResponseBase {
    }
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsUUID)(),
        (0, tslib_1.__metadata)("design:type", String)
    ], ImportResponse.prototype, "templateId", void 0);
    TemplateSharing.ImportResponse = ImportResponse;
})(TemplateSharing = exports.TemplateSharing || (exports.TemplateSharing = {}));
